import { PATH_CONFIG_LOINC } from "../../../../../../shared/constants/route-consts";

export interface ILoincCode {
    loincCodeId: string,
    code: string,
    descriptionEnglish: string,
    descriptionArabic: string
}

export const loincCodeConfig = {
    entityName: "CONFIGURATION.LOINC_CODE.TITLE",
    code: 'FORM_FIELD.CODE',
    descriptionEnglish: "FORM_FIELD.ENGLISH_DESCRIPTION",
    descriptionArabic: "FORM_FIELD.ARABIC_DESCRIPTION",
    uploadExcelData: 'FORM_FIELD.UPLOAD_EXCEL_DATA',
    importTemplateDownload: "COMMON.IMPORT_TEMPLATE_DOWNLOAD"
};

export const loincCodeRoutes = {
    loincCodeDetails: `${PATH_CONFIG_LOINC}/view/`,
    loincCodeEdit: `${PATH_CONFIG_LOINC}/edit/`,
    loincCodeAdd: `${PATH_CONFIG_LOINC}/add`,
    loincCode: PATH_CONFIG_LOINC
};